export enum MoonClass {

    M = 0,

}
